import React from "react";

import { AgendaItemContainer } from "@whoosh/design-system/src/apps/PatronApp/screens/multiSlotBooking";
import { Box, Text } from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

export type BlockCardColorVariant = "A" | "B" | "C" | "D" | "E" | "F" | "Gray";

type BlockCardProps = {
  title: string;
  text?: string;
  durationMins: number;
  colorVariant: BlockCardColorVariant;
};

export const BlockCard = ({
  title,
  text,
  durationMins,
  colorVariant,
}: BlockCardProps) => {
  const bgColor: WhooshThemeColors =
    colorVariant === "Gray"
      ? "grayscale-200"
      : `surface-user-selectable-color${colorVariant}-subtlest`;
  const titleColor: WhooshThemeColors =
    colorVariant === "Gray"
      ? "text-secondary"
      : `text-user-selectable-color${colorVariant}-inverse`;
  const textColor: WhooshThemeColors =
    colorVariant === "Gray"
      ? "text-primary"
      : `text-user-selectable-color${colorVariant}-inverse`;
  const is15MinutesOrLess = durationMins <= 15;
  return durationMins ? (
    <AgendaItemContainer durationMins={durationMins}>
      <Box
        bg={bgColor}
        px={4}
        py={is15MinutesOrLess ? 2 : 3}
        flex={1}
        borderRadius="2"
      >
        <Text color={titleColor} variant="mainSmallSemiBold" mb={2}>
          {title}
        </Text>
        {text ? (
          <Text color={textColor} variant="mainTiny">
            {text}
          </Text>
        ) : null}
      </Box>
    </AgendaItemContainer>
  ) : null;
};
